module.exports = __webpack_public_path__ + "img/code.png.b52b6077.svg";